import "./YesterdayInfo.scss";

import { Modal } from "antd";
import { useState, useEffect } from "react";
import { YesterdayShiftClock } from "../../assets/index";
import { ShiftCard } from "../../../ListPrezenca/timesheet/ProgressShift";
import { useSelector } from "react-redux";
import { ModalXIcon } from "../../../../assets/icons";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import dayjsTZ from "../../../../utils/dayjs";

const YesterdayInfo = ({ showYesterday, handleYesterday, shift, userData }) => {
  const [lastShift, setLastShift] = useState(null);
  const { clockings } = useSelector((state) => state.clockings);
  const { isDarkMode } = useSelector((state) => state.usersList);

  // retrieves the last shift in database with set values for clockInDate and clockOutDate
  async function getLastFinishedShift(emplId) {
    let filtered = clockings?.filter(
      (el) =>
        el.employeeId === emplId &&
        el.clockInDate !== null &&
        el.clockOutDate !== null
    );
    let sorted = filtered.sort((a, b) => a.clockInDate - b.clockInDate).at(-1);
    setLastShift(sorted);
  }
  useEffect(() => {
    if (shift.employeeId !== null && !!clockings) {
      getLastFinishedShift(shift.employeeId);
    }
  }, [shift, clockings]);

  return (
    <div className="yesterday-info-wrapper">
      <Modal
        className={`yesterdayModal ${
          isDarkMode ? "dark darkHeader" : "lightHeader"
        }`}
        centered={true}
        title={`Detaje | ${dayjsTZ(lastShift?.clockInDate).format(
          "DD/MM/YYYY"
        )}`}
        open={showYesterday}
        onOk={() => handleYesterday(false)}
        onCancel={() => handleYesterday(false)}
        footer={[
          <MondayButton
            className="mondayButtonRed"
            onClick={() => handleYesterday(false)}
          >
            Mbylle Faqen
          </MondayButton>,
        ]}
        closeIcon={<ModalXIcon />}
        width={805}
      >
        {!!lastShift ? (
          <div className="yesterday-shift-wrapper">
            {/* <div className="clock-icons">
              <ClockOutIcon className="clock-out-icon" />
              <ClockInIcon className="clock-in-icon" />
            </div> */}
            <div className="dsd">
              <YesterdayShiftClock />
            </div>

            <span className="yesterday-shift-text">
              Përshëndetje {userData?.userAccess[0]?.given_name}{" "}
              {userData?.userAccess[0]?.family_name}
              , <br /> ti në rekordin e fundit{" "}
              <span>
                {" "}
                ke nisur turnin në orën{" "}
                {dayjsTZ(lastShift?.clockInDate).format("HH:mm")},
              </span>{" "}
              dhe e{" "}
              <span>
                ke mbyllur në orën{" "}
                {dayjsTZ(lastShift?.clockOutDate).format("HH:mm")}.
              </span>
            </span>
            <ShiftCard
              info={{
                clockInDate: lastShift?.clockInDate,
                clockOutDate: lastShift?.clockOutDate,
                type: "",
                duration: dayjsTZ(lastShift?.clockOutDate)
                  .diff(dayjsTZ(lastShift?.clockInDate), "hours", true)
                  .toFixed(2),
              }}
              lastShift={lastShift}
            />
          </div>
        ) : (
          <div
            className=""
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <h3 style={{ color: "#ea3943" }}>
              Në rekordet e disponueshme, nuk ekziston një orar i cili ju përket
              juve!
            </h3>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default YesterdayInfo;
